<template>
  <!-- 页脚内容 -->
<!--  <footer class="footer">-->
<!--    <div class="container">-->
<!--      <p>© 2024 好奇星. 个人版权所有.</p>-->
<!--      <p>备案号：您的备案号</p>-->
<!--      <p>联系方式：ghgaojia@163.com</p>-->
<!--    </div>-->
<!--  </footer>-->
  <div class="icp">{{`© ${year} ${author} ` }}<a href="http://beian.miit.gov.cn/" target="_blank">{{ record }}</a></div>
</template>

<script setup>
let year = new Date().getFullYear();        // 一般都是最新的一年
let author = '好奇星';					// 作者名
let record = '豫ICP备20018771号-1';			// 备案号
</script>

<style scoped>
.icp {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 10px 0;
  width: 100%;
  height: 36px;
  white-space: pre;
  text-align: center;
  color: gray;
  z-index: 1000;
}
.icp > a {
  color: gray;
  text-decoration: none;
}
.icp > a:hover {
  color: aqua;
  text-decoration: none;
}
</style>